/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiMatchSourceType {
    ORIGINAL = 'ORIGINAL',
    RFI = 'RFI'
}


export function instanceOfApiMatchSourceType(value: any): boolean {
    for (const key in ApiMatchSourceType) {
        if (Object.prototype.hasOwnProperty.call(ApiMatchSourceType, key)) {
            if (ApiMatchSourceType[key as keyof typeof ApiMatchSourceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiMatchSourceTypeFromJSON(json: any): ApiMatchSourceType {
    return ApiMatchSourceTypeFromJSONTyped(json, false);
}

export function ApiMatchSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiMatchSourceType {
    return json as ApiMatchSourceType;
}

export function ApiMatchSourceTypeToJSON(value?: ApiMatchSourceType | null): any {
    return value as any;
}

export function ApiMatchSourceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiMatchSourceType {
    return value as ApiMatchSourceType;
}

